var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOccupancy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.3 41.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3,16.1c0,1.5-1.2,2.7-2.7,2.7s-2.7-1.2-2.7-2.7,1.2-2.7,2.7-2.7c1.5,0,2.7,1.2,2.7,2.7h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7,19.2c-2.5,0-4.5,2-4.5,4.5v1.8c0,1,.8,1.8,1.8,1.8v3.6c0,1.5,1.3,2.6,2.8,2.6,1.4,0,2.5-1.2,2.6-2.6v-3.6c1,0,1.8-.8,1.8-1.8v-1.8c0-2.5-2-4.5-4.5-4.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8,15.6c1.5,0,2.7-1.2,2.7-2.7s-1.2-2.7-2.7-2.7-2.7,1.2-2.7,2.7,1.2,2.7,2.7,2.7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3,20.6v1.8c0,1-.8,1.8-1.8,1.8v3.6c0,1.5-1.1,2.8-2.6,2.8-1.5,0-2.8-1.1-2.8-2.6,0,0,0-.2,0-.2v-.3c.6-.5.9-1.2.9-2v-1.8c0-1.8-.9-3.5-2.5-4.5.8-2.4,3.3-3.7,5.7-2.9,1.9.6,3.1,2.3,3.1,4.3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5,15.6c1.5,0,2.7-1.2,2.7-2.7s-1.2-2.7-2.7-2.7-2.7,1.2-2.7,2.7,1.2,2.7,2.7,2.7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3,25.5c0,.8.3,1.5.9,2v.3c0,1.5-1.1,2.8-2.6,2.8-1.5,0-2.8-1.1-2.8-2.6,0,0,0-.2,0-.2v-3.6c-1,0-1.8-.8-1.8-1.8v-1.8c0-2.5,2-4.5,4.5-4.5,1.9,0,3.7,1.3,4.3,3.1-1.5,1-2.5,2.7-2.5,4.5v1.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccupancy);
export default __webpack_public_path__ + "static/media/OCCUPANCY.30d8b8e109b8f454f76258ea5fffda24.svg";
export { ForwardRef as ReactComponent };